module.exports = __webpack_public_path__ + "static/media/Kaedehara Kazuha.44e2d916.png";